import type { FaireProductEntity } from "../../entity_types/product";

export const p_26hjqwjo: FaireProductEntity = {
  token: "p_26hjqwjo",
  type: "product",
  name: "Mate For Life Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3d8a81cd7ecf30968dc45be7ad9b48355b5a4a6d6e5d08417ffd99b5dd179896.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/5cec6f01bfae13bf00d4566b5a216f60da623d248dff9dec308197058026a4fd/1528361252.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:48.574Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
